import { createApp } from 'vue'
import FButton from '~/js/components/button'
import FModal from '~/js/components/modal'

const ID = 'js-modal'

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById(ID)
  const redirectUrl = window.location.href
  const encodedUrl = encodeURIComponent(redirectUrl)

  createApp({
    name: 'LayoutsTheme',
    components: {
      FButton,
      FModal,
    },
    data() {
      return {
        addedProducts: [],
        addFailedProducts: [],
        isCartPage: window.location.href.includes('/cart'),
        showAddToCartModal: false,
        showLoginModal: false,
        text: '',
        path: `/account/login?return_url=${encodedUrl}`,
      }
    },
    created() {
      window.addEventListener('cart-added', ($event) => {
        this.addedProducts = $event.detail.items
        this.addFailedProducts = $event.detail.itemsAddFailed
        this.showAddToCartModal = true

        if (this.isCartPage) {
          setTimeout(() => {
            window.scrollTo(0, 0)
            location.reload(true)
          }, 2000)
        }
      })
      window.addEventListener(
        'button-login-required-clicked',
        ($event = CustomEvent()) => {
          this.text =
            ($event.detail && $event.detail.text) ||
            'お気に入りに登録するには<br>'
          this.showLoginModal = true
        }
      )
    },
  }).mount(element)
})

$(document).ready(function () {
  $(document).on('click', '#menu a', function () {
    var li = $(this).parent('li')
    var i = $(' #menu li').index(li)
    $('#results li').hide().eq(i).show()
  })
})

$('document').ready(function () {
  $('.modal-prefecture-list #menu li:nth-child(4) a').trigger('click')
})

$(document).on('click', '.modal-prefecture-list #menu li a', function () {
  $('.modal-prefecture-list #menu li a').removeClass('current')
  $(this).addClass('current')
})
